import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import React from 'react';

// Placeholder para los embebidos que Tiptap no monta como widget vivo bajo la Opción A de D2
// (inline-flow, inline-ops-table). Conserva los `data-*` del marcador original — sin pérdida
// de datos, se restaura el render vivo en D2.5. `InlineSocialOutlineExtension` (widget real) y
// `DatabaseExtension` (su propio placeholder) van aparte.
const EmbedPlaceholderView = ({ node }) => {
    const { id, label, cls } = node.attrs;
    return (
        <NodeViewWrapper>
            <div className={cls || 'doc-embed-placeholder'} data-id={id} contentEditable="false" suppressContentEditableWarning style={{
                border: '1px dashed #cbd5e1', borderRadius: '8px', padding: '16px', margin: '8px 0',
                color: '#64748b', fontSize: '13px', background: '#f8fafc',
            }}>
                <div className="body">{label || 'Contenido embebido'} · se restaura en D2.5</div>
            </div>
        </NodeViewWrapper>
    );
};

export const EmbedPlaceholderExtension = Node.create({
    name: 'embedPlaceholder',
    group: 'block',
    atom: true,

    addAttributes() {
        return {
            id: { default: null },
            label: { default: '' },
            cls: { default: '' },
        };
    },

    parseHTML() {
        return [
            { tag: 'div.doc-inlineflow-block', getAttrs: (n) => ({ id: n.getAttribute('data-id'), label: n.getAttribute('data-embed-label') || 'Diagrama de flujo', cls: 'doc-inlineflow-block' }) },
            { tag: 'div.doc-inline-ops-table-block', getAttrs: (n) => ({ id: n.getAttribute('data-id'), label: n.getAttribute('data-embed-label') || 'Tabla de operaciones', cls: 'doc-inline-ops-table-block' }) },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes({ class: HTMLAttributes.cls || 'doc-embed-placeholder' }, { 'data-id': HTMLAttributes.id })];
    },

    addNodeView() {
        return ReactNodeViewRenderer(EmbedPlaceholderView);
    },
});
